import { t, useLanguage } from "../../i18n";
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { publicAPI } from '../../services/api';
import { useCartStore } from '../../store';
export default function ScanTableEntry() {
  useLanguage();
  const {
    establishmentId,
    tableNumber
  } = useParams();
  const navigate = useNavigate();
  const setTable = useCartStore(state => state.setTable);
  const clearCart = useCartStore(state => state.clearCart);
  useEffect(() => {
    const resolveTable = async () => {
      try {
        const response = await publicAPI.resolveTable(establishmentId, tableNumber);
        const {
          table,
          establishment
        } = response.data;
        clearCart();
        setTable(table.id, establishment.id);
        await publicAPI.trackEvent({
          event_type: 'menu_viewed',
          table_id: table.id
        });
        navigate('/menu', {
          replace: true
        });
      } catch (err) {
        toast.error(t("Table introuvable"));
        navigate(`/entry/${establishmentId}`, {
          replace: true
        });
      }
    };
    if (establishmentId && tableNumber) {
      resolveTable();
    }
  }, [establishmentId, tableNumber, navigate, setTable, clearCart]);
  return <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center">
      <div className="flex items-center gap-3 text-gray-600">
        <Loader2 className="w-5 h-5 animate-spin" />
        <span>{t("Vérification de la table...")}</span>
      </div>
    </div>;
}
